"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable react/jsx-no-bind */
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var empty_state_1 = tslib_1.__importDefault(require("../empty-state"));
var DirectionRight_1 = require("../Icons/DirectionRight");
var NormalClose_1 = require("../Icons/NormalClose");
var tooltip_1 = tslib_1.__importDefault(require("../tooltip"));
var utils_1 = require("./utils");
var Selection = function (props) {
    var dataSource = props.dataSource, selectedKeys = props.selectedKeys, className = props.className, onChange = props.onChange;
    var selectedItems = (0, react_1.useMemo)(function () {
        (0, utils_1.checkSelectStatus)(dataSource, selectedKeys);
        var parentStack = [];
        var renderItems = [];
        var loopForItem = function (dataSource) {
            dataSource.map(function (item) {
                var isSelected = item.isSelected, indeterminate = item.indeterminate, children = item.children;
                if (isSelected) {
                    renderItems.push(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(parentStack), false), [item], false));
                }
                else if (indeterminate) {
                    parentStack.push(item);
                    loopForItem(children);
                    parentStack.pop();
                }
            });
        };
        loopForItem(dataSource);
        return renderItems;
    }, [dataSource, selectedKeys]);
    var clearSelectedItem = (0, react_1.useCallback)(function () {
        selectedItems.length && onChange([]);
    }, [selectedItems]);
    return (react_1.default.createElement("section", { className: (0, classnames_1.default)('anq-cascader-result-panel', className) },
        react_1.default.createElement("div", { className: "anq-cascader-panel-header" },
            react_1.default.createElement("span", { className: "anq-cascader-panel-left" },
                react_1.default.createElement("span", { className: "anq-cascader-panel-title" }, "\u5DF2\u9009"),
                react_1.default.createElement("span", { className: "anq-cascader-panel-txt" }, selectedItems.length)),
            react_1.default.createElement("span", { className: (0, classnames_1.default)({
                    'anq-cascader-panel-disabled': selectedItems.length === 0,
                }, 'anq-cascader-panel-right'), onClick: clearSelectedItem }, "\u5168\u90E8\u6E05\u7A7A")),
        react_1.default.createElement("div", { className: "anq-cascader-content" }, selectedItems === null || selectedItems === void 0 ? void 0 :
            selectedItems.map(function (item) {
                var _a;
                var lastItem = item[item.length - 1];
                var keys = item.map(function (v) { return v.key; }).join('-');
                var title = (_a = item
                    .map(function (v) { return v.title; })) === null || _a === void 0 ? void 0 : _a.reduce(function (pr, cur) {
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        pr,
                        pr && react_1.default.createElement(DirectionRight_1.DirectionRight, { className: 'anq-cascader-result-panel-title-icon' }),
                        cur));
                }, '');
                return (react_1.default.createElement("div", { className: "anq-cascader-panel-item", key: keys },
                    react_1.default.createElement(tooltip_1.default, { title: title },
                        react_1.default.createElement("div", { className: "anq-cascader-panel-txt" }, title)),
                    react_1.default.createElement("div", { className: "anq-cascader-panel-clear", onClick: function () {
                            var selectedKeys = selectedItems.reduce(function (pre, current) {
                                var isCurrent = current[current.length - 1].key !== lastItem.key;
                                isCurrent && pre.push(current[current.length - 1].key);
                                return pre;
                            }, []);
                            onChange(selectedKeys);
                        } },
                        react_1.default.createElement(NormalClose_1.NormalClose, { className: "anq-cascader-panel-clear-icon" }))));
            }),
            (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) === 0 && (react_1.default.createElement("div", { className: "anq-cascader-panel-no-data" },
                react_1.default.createElement(empty_state_1.default, null))))));
};
exports.default = Selection;
//# sourceMappingURL=Selection.js.map